/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { Button } from '@mui/material';
import { InsightIcon } from '@/components/icons/InsightIcon';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { WinbeatIcon } from '@/components/icons/WinbeatIcon';

export const NavigateInsightButton = ({ insightId, policy }) => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const {
		data: userDetails,
		isLoading,
		isUninitialized,
	} = useGetUserDetailsQuery(
		{ email },
		{
			skip: !email,
		},
	);
	const isWinbeatLedger = userDetails?.isWinbeatLedger;

	const navigateToInsight = () => {
		let slug;

		if (policy?.Id) {
			slug = `/#/policy/${policy.Id}/policy-transaction`;
		} else {
			slug = `/#/client/${insightId}/policy-transaction?isCoClientParam=false&isEditModeParam=&showFilter=ShowLatest`;
		}

		const url = `${userDetails?.insightUrl}${slug}`;
		window.open(url, '_blank');
	};

	return isLoading || isUninitialized ? (
		<></>
	) : (
		<Button
			sx={(theme) => ({
				borderRadius: '10px',
				...(isWinbeatLedger && {
					color:
						theme.palette.mode === 'dark'
							? theme.palette.winbeatOrange
							: theme.palette.winbeatNavy,
					border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.winbeatOrange : theme.palette.winbeatNavy}`,
				}),
			})}
			variant='outlined'
			disabled={!userDetails?.insightUrl}
			onClick={navigateToInsight}
			startIcon={isWinbeatLedger ? <WinbeatIcon /> : <InsightIcon />}
		>
			{!policy?.Id ? `Open in ${isWinbeatLedger ? 'WINBEAT' : 'INSIGHT'}` : 'Open Policy'}
		</Button>
	);
};
